import {
  DIFFICULTY_WEIGHTS,
  ACCURACY_TABLE,
  ACCURACY_DELTA,
} from "../../data/difficultyWeights";

const clamp01 = (x) => Math.max(0, Math.min(1, x));

const computeAccuracy = (band) => {
  const base = ACCURACY_TABLE[band];
  if (!base) {
    return {
      perDifficulty: { l1: null, l2: null, l3: null },
      overall: { low: null, est: null, high: null },
    };
  }

  const [a1, a2, a3] = base;

  const low = [
    clamp01(a1 - ACCURACY_DELTA),
    clamp01(a2 - ACCURACY_DELTA),
    clamp01(a3 - ACCURACY_DELTA),
  ];
  const high = [
    clamp01(a1 + ACCURACY_DELTA),
    clamp01(a2 + ACCURACY_DELTA),
    clamp01(a3 + ACCURACY_DELTA),
  ];

  const w = DIFFICULTY_WEIGHTS;

  return {
    perDifficulty: { l1: a1, l2: a2, l3: a3 },
    overall: {
      est: w.l1 * a1 + w.l2 * a2 + w.l3 * a3,
      low: w.l1 * low[0] + w.l2 * low[1] + w.l3 * low[2],
      high: w.l1 * high[0] + w.l2 * high[1] + w.l3 * high[2],
    },
  };
};

export const estimatePillarScore = ({
  pillar,
  skillBandMap,
  totalQuestions, // 🔑 66 or 54
}) => {
  let totalRawWeight = 0;
  const rows = [];

  pillar.topics.forEach((topic) => {
    topic.skills.forEach((skill) => {
      const rawWeight = (topic.topicWeight ?? 0) * (skill.weight ?? 0);
      totalRawWeight += rawWeight;

      rows.push({
        code: skill.code,
        name: skill.name,
        band: skillBandMap[skill.code] ?? null,
        rawWeight,
      });
    });
  });

  return rows.map((r) => {
    const normWeight = totalRawWeight > 0 ? r.rawWeight / totalRawWeight : 0;
    const questions = totalQuestions * normWeight;

    const acc = computeAccuracy(r.band);

    return {
      ...r,
      normWeight,
      questions,

      accL1: acc.perDifficulty.l1,
      accL2: acc.perDifficulty.l2,
      accL3: acc.perDifficulty.l3,

      accLow: acc.overall.low,
      accEst: acc.overall.est,
      accHigh: acc.overall.high,

      correctLow: acc.overall.low != null ? questions * acc.overall.low : null,
      correctEst: acc.overall.est != null ? questions * acc.overall.est : null,
      correctHigh: acc.overall.high != null ? questions * acc.overall.high : null,
    };
  });
};
